<template>
  <div>
    <v-card flat class="mt-2">
      <v-form class="multi-col-validation">
        <v-card-title>Register Lanjutan Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain</v-card-title>
        <v-card-text class="">
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.username" label="Username :" dense outlined readonly></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.email" label="Email :" dense outlined readonly></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.nama" label="Nama :" dense outlined readonly></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.nim" label="NIM :" dense outlined readonly></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-autocomplete
                v-model="userSelected.id_institusi"
                :items="institusi_pendidikans"
                outlined
                dense
                label="Institusi Pendidikan :"
                item-text="nama"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="3">
              <v-autocomplete
                v-model="userSelected.id_prodi"
                :items="prodis"
                outlined
                dense
                label="Prodi :"
                item-text="nama"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="3">
              <v-btn small color="primary" @click="simpanEdit()">Simpan Edit</v-btn>
            </v-col>
          </v-row>
          <h3 class="ml-2 mt-2">Upload Dokumen :</h3>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">No</th>
                  <th class="text-left">Nama</th>
                  <th class="text-left">File</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dokumens" v-bind:key="item.id">
                  <td>{{ parseInt(index) + 1 }}</td>
                  <td>{{ item.nama }}</td>
                  <td><uploaded-dokumen-registrasi :namaDokumen="item.kode"></uploaded-dokumen-registrasi></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import UploadedDokumenRegistrasi from '@/components/upload/UploadedDokumenRegistrasi.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
  components: {
    UploadedDokumenRegistrasi,
  },
  data: () => ({
    userTambahan: {
      username: '',
      email: '',
      nama: '',
      nim: '',
      institusi_pendidikan: '',
      prodi: '',
      dokumen: [],
    },
    dokumens: [],
    institusi_pendidikans: [],
    prodis: [],
  }),
  computed: {
    headers() {
      return {
        Authorization: this.$store.state.token,
      }
    },
    userSelected() {
      return this.$store.getters.userSelected
    },
  },
  watch: {
    userSelected: function () {
      this.getDokumenRequirement()
      this.getInstitusiPendidikan()
      this.getProdi()
    },
  },
  created() {
    this.getDokumenRequirement()
    this.getInstitusiPendidikan()
    this.getProdi()
  },
  methods: {
    getDokumenRequirement() {
      let fmData = new FormData()
      fmData.append('profesi', 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain')
      axiosPostAuth('api/RegisterLanjutan/getDokumenRequirement', fmData).then(response => {
        this.dokumens = Object.assign({}, response.data)
      })
    },
    getInstitusiPendidikan() {
      const headers = this.headers
      axios
        .get(`${apiRoot}/api/RegisterLanjutan/getInstitusiPendidikans`, { headers })
        .then(response => {
          if (response.data.code === 200) {
            this.institusi_pendidikans = response.data.datas
          } else {
            alert(response.data.message)
          }
        })
        .catch(error => {
          alert(error)
        })
    },
    getProdi() {
      // this.loading = true
      const headers = this.headers
      axios
        .get(`${apiRoot}/api/RegisterLanjutan/getProdis`, { headers })
        .then(response => {
          if (response.data.code === 200) {
            this.prodis = response.data.datas
          } else {
            alert(response.data.message)
          }
        })
        .catch(error => {
          alert(error)
        })
    },
    simpanEdit() {
      let conf = confirm('Apakah yakin akan perubahan akan disimpan?')
      if (conf) {
        const headers = this.headers
        const fmData = new FormData()
        fmData.append('user_id', this.userSelected.id)
        // fmData.append('username', this.userTambahan.username)
        // fmData.append('username', this.userTambahan.username)
        // fmData.append('email', this.userTambahan.email)
        // fmData.append('nama', this.userTambahan.nama)
        // fmData.append('nim', this.userTambahan.nim)
        fmData.append('institusi_pendidikan', this.userSelected.id_institusi)
        fmData.append('prodi', this.userSelected.id_prodi)
        // const dokumen = []
        // this.userTambahan.dokumen.forEach(element => {
        //   dokumen.push(element.id)
        // })
        // fmData.append('dokumen', dokumen)
        // fmData.append('role_temp', this.userSelected.role_temp)
        axios
          .post(`${apiRoot}/api/RegisterLanjutan/editRegistrasiPesertaKeparawatanDll`, fmData, { headers })
          .then(response => {
            if (response.data.code === 200) {
              this.$notify({
                type: 'success',
                title: 'Berhasil',
                text: response.data.message,
              })
            } else {
              alert(response.data.message)
            }
          })
          .catch(error => {
            alert(error)
          })
      }
    },
  },
}
</script>